<template>
  <Modal :show.sync="showDialog" v-if="jsonLogIn" @close="modalClosed()" modalClasses="day">
    <div class="modal-top-radius element-background-color login-logo text-center">
      <img :src="jsonLogIn.logIn.img">
    </div>
    <div class="btn-wrapper text-center margin-top-24">
    </div>
    <div v-if="wrongCredentials" class="text-center border border-warning padding-25 warning-info-box-background-color">
      <p class="black-font-color" v-html="errorMessages.login.wrongCredentials"></p>
    </div>
    <div v-if="!forgotPassword">
      <div class="text-center text-muted margin-top-24">
        <small v-html="jsonLogIn.logIn.register"></small>
      </div>
      <ElForm role="form" class="is-invalid">
        <InputsBaseInput alternative v-bind:class="{ 'has-danger': wrongCredentials }" type="email"
          :placeholder=jsonLogIn.logIn.mail addon-left-icon="tim-icons icon-email-85 black-font-color" v-model="logInMail"
          @keydown="triggerLoginIfEnter">
        </InputsBaseInput>
        <InputsBaseInput alternative v-bind:class="{ 'has-danger': wrongCredentials }" type="password"
          :placeholder=jsonLogIn.logIn.password addon-left-icon="tim-icons icon-lock-circle black-font-color"
          v-model="logInPassword" @keydown="triggerLoginIfEnter">
        </InputsBaseInput>
        <div class="text-center">
          <BaseButton type="primary" class="my-4" :disabled="shouldDisableNextPasswordNameAndEmail()"
            @click="submitLogInData()">{{
              jsonLogIn.logIn.buttontext
            }}
          </BaseButton>
        </div>
        <div class="text-center cursor-pointer">
          <small><a @click="forgotPassword = true; wrongCredentials = false" class="font-weight-bolder">{{
            jsonLogIn.logIn.forgot_password }}</a></small>
        </div>
      </ElForm>
    </div>
    <div v-if="forgotPassword">
      <div class=" text-muted margin-top-24">
        <h4 class="black-font-color font-weight-bold" v-html="jsonLogIn.logIn.pwResetTitle"></h4>
        <p class="text-left" v-html="jsonLogIn.logIn.pwResetText"></p>
      </div>
      <form role="form" class="is-invalid">
        <InputsBaseInput alternative v-bind:class="{ 'has-danger': wrongCredentials }" type="email"
          :placeholder=jsonLogIn.logIn.mail addon-left-icon="tim-icons icon-email-85 black-font-color"
          v-model="logInMail">
        </InputsBaseInput>
        <div class="text-center">
          <BaseButton type="primary" class="my-4" :disabled="!(!!logInMail)" @click=" passwordReset()">
            {{ jsonLogIn.logIn.pwResetButton }}
          </BaseButton>
        </div>
      </form>
    </div>
  </Modal>
</template>

<script lang="ts" setup>
import { isValidEmail } from "~/modules/common/services/util/validations";
import { ApplicationScope } from "~/api-client";
import errormessages from "~/content/errormessages.json"
import elements_json from "~/content/elements.json";

const props = defineProps({
  LoginScreen: {
    type: Boolean,
    default: false
  },
  redirectTo: {
    type: String,
    default: '/dashboard'
  }
});

const emit = defineEmits<{
  (e: 'closed', data: boolean): void,
}>();

const { $backendService, $logger, $router } = useNuxtApp();
// const auth = useAuth();

const forgotPassword = ref(false);
const jsonLogIn = ref(elements_json);
const errorMessages = ref(errormessages);
const showMenu = ref(false);
const logInMail = ref('');
const logInPassword = ref('');
const wrongCredentials = ref(false);
const showDialog = ref(props.LoginScreen);

watch(() => props.LoginScreen, (newVal) => {
  showDialog.value = newVal;
});

const modalClosed = () => {
  showDialog.value = false;
  forgotPassword.value = false;
  wrongCredentials.value = false;
  logInMail.value = '';
  logInPassword.value = '';
  emit('closed', true);
};

const triggerLoginIfEnter = async (event: KeyboardEvent) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    await submitLogInData();
  }
};

const shouldDisableNextPasswordNameAndEmail = () => {
  return !logInPassword.value ||
    !logInMail.value ||
    !isValidEmail(logInMail.value);
};

const submitLogInData = async () => {
  try {
    // let response = await auth.signIn('local', {
    //   data: {
    //     username: logInMail.value,
    //     password: logInPassword.value
    //   }
    // })
    // if (response.status === 200) {
    //   // this.$root.$emit('userInfoChanged');
    //   modalClosed();
    //   $router.push(props.redirectTo);
    // }
  } catch (err) {
    ElMessage.error('Beim Anmelden ist ein Fehler aufgetreten');
    wrongCredentials.value = true;
  }
};

const passwordReset = () => {
  $backendService.registrationControllerApi.requestPasswordReset({
    xApplicationScope: ApplicationScope.MyDb,
    passwordReset: {
      username: logInMail.value
    }
  }).then(() => {
    ElMessage.success('Eine E-Mail mit Bestätigungscode wurde versandt.');
    // auth.logout();
    modalClosed();
  }).catch((error) => {
    ElMessage.error('Leider ist ein Fehler aufgetreten.');
  });
};
</script>
<style></style>
